// extracted by mini-css-extract-plugin
export var logo = "_9n-2";
export var logoWrapper = "_9n-1";
export var strip = "_9n-0";